import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { GlobalContext } from '../../services/context/DataContext';
import useTabs from '../../services/customHooks/useTabs';

export const useViewTab = () => {
  const { permissionsData } = useContext(GlobalContext);
  const [permissions] = permissionsData;
  const navigate = useNavigate();
  const { tabs } = useTabs();

  // ShowMap function using to redirect to google map page.
  const handleClick = (tabName, id) => {
    navigate(`/tab/${tabName}/${id}`);
  };

  return { permissions, tabs, handleClick };
};
